// Layout rules shared by the card renderers (CardList, BoardCard, DynamicIssueCard).
//
// A card's `subtitle` is a row of its own: `primary` on the left, `secondary` on the right. When a scheme config leaves the
// primary out (or it has no value for this record) and only the secondary is set — a "last status update" time, say — that row
// would be a blank line with the time at its end, and the body starts below it. Instead the secondary rides on the first body
// row that has something to show, so the card stays as compact as its content, whatever the config holds.

// host elements that only wrap their content: empty when what they wrap is
const WRAPPERS = ['div', 'span', 'p', 'b', 'strong', 'i', 'em']

// Nothing to show: no value, a blank string, or a list / wrapper element holding nothing but such values. A component element
// (a chip, a file list, …) always counts as content.
export const isEmptyContent = (node) => {
  if (node === null || node === undefined || typeof node === 'boolean') return true
  if (typeof node === 'string') return node.trim() === ''
  if (typeof node === 'number') return false
  if (Array.isArray(node)) return node.every(isEmptyContent)
  if (typeof node === 'object' && typeof node.type === 'string' && WRAPPERS.includes(node.type)) return isEmptyContent(node.props?.children)
  return false
}

// The body row (an index into `bodyRows`) a subtitle's secondary folds into, or -1 when the subtitle keeps its own row: it has a
// primary, it has no secondary, or there is no body row with content to share a line with.
export const subtitleFoldIndex = (subtitle, bodyRows) => {
  if (!subtitle || isEmptyContent(subtitle.secondary) || !isEmptyContent(subtitle.primary)) return -1
  return (bodyRows || []).findIndex((row) => !isEmptyContent(row))
}
